import React from 'react';
import Form from '#/common/components/Form';
import fields from './fields';
import type { SyncHistoryFormRecord } from '#/modules/admin/syncHistory/utils/fields';

export interface SyncHistoryFormProps {
  syncHistory: SyncHistoryFormRecord;
}

const SyncHistoryForm: React.FC<SyncHistoryFormProps> = ({ syncHistory }) => {
  return <Form record={syncHistory} fields={fields} readonly />;
};

export default React.memo(SyncHistoryForm);
